import fetch from './AxiosAdapter';
import config from '../misc/Configuracao';
import { CategoriaMinuta } from '../modelo';
import MensagemStore from '../store/MensagemStore';
import { apresentarApiErroPadrao } from '@/utils/ApiErroPadraoUtils';

class CategoriaMinutaApi {

    async associarCategoriasAMinuta(idProcesso: number, tipoMinuta: number, categorias: CategoriaMinuta[]) {
        let result;
        try {
            result = await fetch(config.urlCategoriaMinuta.replace(config.idProcesso, idProcesso.toString()).replace(config.tipoMinuta, tipoMinuta.toString()),
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: categorias
                });
            MensagemStore.apresentarMensagem('Categorias associadas com sucesso.');
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            const mensagemDeErro = "Não foi possível associar a(s) categoria(s) à minuta. ";
            const message = mensagemDeErro + erro + " " + (result ? result.statusText : "");
            console.error(message);
            MensagemStore.apresentarErro(mensagemDeErro);
            throw new Error(message);
        }

        return result.data;
    }

    async recuperarCategoriasDaMinuta(idProcesso: number, tipoMinuta: number) {
        let result;
        try {
            result = await fetch(config.urlCategoriaMinuta.replace(config.idProcesso, idProcesso.toString()).replace(config.tipoMinuta, tipoMinuta.toString()));
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            const mensagemDeErro = "Não foi possível associar a(s) categoria(s) à minuta. ";
            const message = mensagemDeErro + erro + " " + (result ? result.statusText : "");
            console.error(message);
            MensagemStore.apresentarErro(mensagemDeErro);
            throw new Error(message);
        }

        return result.data;
    }

}

export default new CategoriaMinutaApi();